import { render } from "./DefaultDatabaseDetailCmp.vue?vue&type=template&id=3623f995"
import script from "./DefaultDatabaseDetailCmp.vue?vue&type=script&lang=js"
export * from "./DefaultDatabaseDetailCmp.vue?vue&type=script&lang=js"

import "./DefaultDatabaseDetailCmp.vue?vue&type=style&index=0&id=3623f995&lang=css"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__